import React from 'react';
import { Transition } from 'react-transition-group';
import classnames from 'classnames';

import './Fade.scss';

export interface FadeProps {
    /**
     * Tag
     */
    tag?: any;
    /**
     * Class name transition
     * @default: 'fade'
     */
    baseClass?: string;
    /**
     * Class name active transition
     * @default: 'show'
     */
    baseClassActive?: string;
    /**
     * In Transtion
     */
    in?: boolean;
    /**
     * Appear Transtion
     */
    appear?: boolean;
    /**
     * Enter Transtion
     */
    enter?: boolean;
    /**
     * Exit Transtion
     */
    exit?: boolean;
    /**
     * Timeout transtion
     */
    timeout?: number;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style Fade
     */
    style?: any;
    /**
     * onClick function
     */
    onClick?(): any;
    /**
     * onEntering function
     */
    onEntering?(node: any, isAppearing: any): any;
    /**
     * onEntered function
     */
    onEntered?(node: any, isAppearing: any): any;
    /**
     * onExit function
     */
    onExit?(node: any): any;
    /**
     * onExiting function
     */
    onExiting?(node: any): any;
    /**
     * onExited function
     */
    onExited?(node: any): any;
    /**
     * Slot component
     */
    children?: React.ReactNode;
}

const Fade: React.FC<FadeProps> = ({
    tag: Tag = 'div',
    baseClass = 'fade',
    baseClassActive = 'show',
    timeout = 150,
    appear = true,
    enter = true,
    exit = true,
    in: inTransition = true,
    className,
    style = {},
    children,
    onClick = () => {},
    onEntering = () => {},
    onEntered = () => {},
    onExit = () => {},
    onExiting = () => {},
    onExited = () => {},
}) => {
    const nodeRef = React.createRef() as any;
    const renderChildren = (status: string) => {
        const isActive = status === 'entered';
        const classNames = classnames(className, baseClass, isActive && baseClassActive);
        return (
            <Tag className={classNames} style={style} onClick={onClick}>
                {children}
            </Tag>
        );
    };

    return (
        <Transition
            nodeRef={nodeRef}
            in={inTransition}
            appear={appear}
            enter={enter}
            exit={exit}
            timeout={timeout}
            onEntering={onEntering}
            onEntered={onEntered}
            onExit={onExit}
            onExiting={onExiting}
            onExited={onExited}
        >
            {renderChildren}
        </Transition>
    );
};

export default Fade;
